const colors = [
  'black',
  'white',
  '#E9787A',
  '#F06291',
  '#BA69C9',
  '#7A87CC',
  '#43C0FF',
  '#4FCFD7',
  '#72C392',
  '#F3D457',
  '#FFA826',
  '#8D6E62',
];

const gradients = [
  'linear-gradient(90deg, #007991 0%, #78FFD6 100%)',
  'linear-gradient(90deg, #36D1DC 0%, #5B86E5 100%)',
  'linear-gradient(90deg, #CB356B 0%, #BD3F32 100%)',
  'linear-gradient(90deg, #D275BC 0%, #E3ADF1 100%)',
  'linear-gradient(90deg, #E7865C 0%, #A46071 52.8%, #6768BF 100%)',
  'linear-gradient(109.71deg, #6A4FAB 0%, #B39BE4 58.11%, #8F84FE 103.49%)',
  'linear-gradient(100.99deg, #FCEA68 16.33%, #FFBC16 95.21%)',
  'linear-gradient(107.4deg, #DDBD77 0%, #D7825E 56.19%, #F17269 98.83%)',
  'linear-gradient(107.4deg, #238590 0%, #E08F8C 98.83%)',
  'linear-gradient(100.99deg, #C0BBB8 16.33%, #324B69 66.66%, #803944 95.21%)',
  'linear-gradient(107.4deg, #5CA5EB 0%, #5246A9 56.19%, #1D518D 98.83%)',
  'linear-gradient(106.49deg, #BAF608 0%, #59CB51 47.38%, #249640 83.34%), #8D6E62',
];

const gathering = [
  'https://d5mup2f167kag.cloudfront.net/assets/public/ebc2cd83-fa41-4504-9928-dddb98e5d67b-gathering-background-room.png',
  'https://d5mup2f167kag.cloudfront.net/assets/public/42688ab8-948d-450c-af2e-b78d3e3e9e7b-gathering-background-room-with-buildings.png',
  'https://d5mup2f167kag.cloudfront.net/assets/public/c3219f4c-585b-4a4a-a8a5-eeff906f63b8-gathering-background-meeting-room.png',
  'https://d5mup2f167kag.cloudfront.net/assets/public/1d5f4f2d-61dd-438d-908b-f2d42b047cf4-gathering-background-loft.png',
  'https://d5mup2f167kag.cloudfront.net/assets/public/5e5384cb-f530-4818-a84d-75d2c393b3a5-gathering-background-shelves.png',
  'https://d5mup2f167kag.cloudfront.net/assets/public/d6f05d08-dc10-4793-8fe1-988f4c943bec-gathering-background-loft2.png',
  'https://d5mup2f167kag.cloudfront.net/assets/public/0dc0ca0d-af95-44e7-bdba-9821f79c792b-gathering-background-white-shelves.png',
  'https://d5mup2f167kag.cloudfront.net/assets/public/ccc1abf6-2fd7-492b-8c2d-c25edb0700d2-gathering-background-coworking.png',
  'https://d5mup2f167kag.cloudfront.net/assets/public/78a16566-63d0-4c10-9445-98ebd87fd21a-gathering-background-coworking2.png',
  'https://d5mup2f167kag.cloudfront.net/assets/public/d5511b9a-a905-470e-9037-df81bfc18674-gathering-background-loft3.png',
  'https://d5mup2f167kag.cloudfront.net/assets/public/cb67b62a-3cd9-4f85-aa8d-03cb44a32acb-gathering-background-coworking3.png',
  'https://d5mup2f167kag.cloudfront.net/assets/public/3ef779c7-30a2-4f94-a79f-86d5173a30ac-gathering-background-backyard.png',
];

const architectures = [
  'https://d5mup2f167kag.cloudfront.net/assets/public/84fe2c2e-0010-42ec-bfbb-c6872172c9ac-architectures-1.jpg',
  'https://d5mup2f167kag.cloudfront.net/assets/public/04f61634-93cf-4386-a86d-21e5cbb88a58-architectures-2.jpg',
  'https://d5mup2f167kag.cloudfront.net/assets/public/f76fbb67-ad0f-4b83-86ca-84169780b319-architectures-3.jpg',
  'https://d5mup2f167kag.cloudfront.net/assets/public/2a5968d4-ab69-455a-b4c6-de1b4591ca5f-architectures-4.jpg',
  'https://d5mup2f167kag.cloudfront.net/assets/public/eb8647c7-b77c-48a0-b4e9-de90cd51b3e2-architectures-5.jpg',
  'https://d5mup2f167kag.cloudfront.net/assets/public/3c31b322-0954-43b8-be45-b63f258cacf7-architectures-6.jpg',
  'https://d5mup2f167kag.cloudfront.net/assets/public/e9e96969-b18f-4891-80b0-1dac61f6786e-architectures-7.jpg',
  'https://d5mup2f167kag.cloudfront.net/assets/public/7d01f353-0d24-49b6-a9f1-d39d59c98f50-architectures-8.jpg',
  'https://d5mup2f167kag.cloudfront.net/assets/public/586a8090-a3fc-49a8-8499-799a309eb190-architectures-9.jpg',
  'https://d5mup2f167kag.cloudfront.net/assets/public/3a97e0b2-33a0-44c3-983e-24ebf9addbc1-architectures-10.jpg',
  'https://d5mup2f167kag.cloudfront.net/assets/public/7e6c334c-fc40-40bf-9c4c-d51bac4bc4df-architectures-11.jpg',
  'https://d5mup2f167kag.cloudfront.net/assets/public/a11e6406-af6a-454d-95cc-53dd3c2cbe49-architectures-12.jpg',
  'https://d5mup2f167kag.cloudfront.net/assets/public/341f9cca-b974-4d44-9df0-ccf495b37334-architectures-13.jpg',
  'https://d5mup2f167kag.cloudfront.net/assets/public/64b0754e-e899-4efb-93ca-fc6868a1953e-architectures-14.jpg',
  'https://d5mup2f167kag.cloudfront.net/assets/public/a710c3f1-d0c1-4677-9673-a22e2fa030c4-architectures-15.jpg',
  // 'https://d5mup2f167kag.cloudfront.net/assets/public/515bd6c8-69e3-4647-b066-26f2d46b22a3-architectures-16.jpg',
];

const landScape = [
  'https://d5mup2f167kag.cloudfront.net/assets/public/b9572ea4-272f-4443-a663-1345b3fad75d-landscape-1.jpg',
  'https://d5mup2f167kag.cloudfront.net/assets/public/24328aca-3579-455a-bd6c-d29a0da42d0b-landscape-2.jpg',
  'https://d5mup2f167kag.cloudfront.net/assets/public/1aced859-b458-463d-b091-b1842c3a3852-landscape-3.jpg',
  'https://d5mup2f167kag.cloudfront.net/assets/public/23a0c49b-5ad6-49f0-99bf-fbaa157b552d-landscape-4.jpg',
  'https://d5mup2f167kag.cloudfront.net/assets/public/bf421ef1-dc39-47f9-a602-c061c49954a0-landscape-5.jpg',
  'https://d5mup2f167kag.cloudfront.net/assets/public/ea54b36f-02f9-4dbe-b429-93acad93280c-landscape-6.jpg',
  'https://d5mup2f167kag.cloudfront.net/assets/public/9a45b052-628e-4973-b760-ae66650dda94-landscape-7.jpg',
  'https://d5mup2f167kag.cloudfront.net/assets/public/32ff4731-27cb-4f6c-9bf7-e81f5f3cc8b9-landscape-8.jpg',
  'https://d5mup2f167kag.cloudfront.net/assets/public/4e63b54e-e791-443f-9b76-8feac1e0195d-landscape-9.jpg',
  'https://d5mup2f167kag.cloudfront.net/assets/public/ade7ea63-9a62-4588-9822-da6b5afdf348-landscape-10.jpg',
  'https://d5mup2f167kag.cloudfront.net/assets/public/dd92d4dc-31ba-4053-89bc-1204ca9cc69b-landscape-11.jpg',
  'https://d5mup2f167kag.cloudfront.net/assets/public/1c560d4d-9021-47c9-bf96-08460e193776-landscape-12.jpg',
  'https://d5mup2f167kag.cloudfront.net/assets/public/7461bf7c-8d37-44dd-a66e-b1a832fff4d8-landscape-13.jpg',
  'https://d5mup2f167kag.cloudfront.net/assets/public/232e532c-50e2-4c25-a6d4-1305e955e6d8-landscape-14.jpg',
  'https://d5mup2f167kag.cloudfront.net/assets/public/2f83177f-e520-44a7-86cb-eace9b3a200f-landscape-15.jpg',
  // 'https://d5mup2f167kag.cloudfront.net/assets/public/aafc549a-66b4-45a2-9cbb-0f15c56cd080-landscape-16.jpg',
];

const space = [
  'https://d5mup2f167kag.cloudfront.net/assets/public/6f3c8fb6-b626-4e3b-ac7b-0669eb255160-space-1.jpg',
  'https://d5mup2f167kag.cloudfront.net/assets/public/6b038070-a7ab-449c-84a4-7d18e26e78c5-space-2.jpg',
  'https://d5mup2f167kag.cloudfront.net/assets/public/5c99b2b1-038b-40a7-9065-53c047835a84-space-3.jpg',
  'https://d5mup2f167kag.cloudfront.net/assets/public/c22f67e8-c160-47ef-a56e-740cdfeb0ac7-space-4.jpg',
  'https://d5mup2f167kag.cloudfront.net/assets/public/717978b6-4937-46ef-86df-685e24aa6535-space-5.jpg',
  'https://d5mup2f167kag.cloudfront.net/assets/public/fa73613b-7629-4b52-a84b-310938eb872c-space-6.jpg',
  'https://d5mup2f167kag.cloudfront.net/assets/public/d7673d89-503d-48ba-a862-519e0130a64d-space-7.jpg',
  'https://d5mup2f167kag.cloudfront.net/assets/public/27430168-c9f3-4ad7-8365-335bfd933db2-space-8.jpg',
  'https://d5mup2f167kag.cloudfront.net/assets/public/80e31277-ce35-4ffa-99e9-fc4d6036c840-space-9.jpg',
  'https://d5mup2f167kag.cloudfront.net/assets/public/33b86da1-1919-4f35-bd59-3eb0d6e851d7-space-10.jpg',
  'https://d5mup2f167kag.cloudfront.net/assets/public/e0960a7e-608b-4bd9-8c32-ea8eb1d6237d-space-11.jpg',
  'https://d5mup2f167kag.cloudfront.net/assets/public/9be7361b-4da0-4a1c-a344-d8a3ec951792-space-12.jpg',
  'https://d5mup2f167kag.cloudfront.net/assets/public/ea130734-5af2-405e-b5cb-d2945930467f-space-13.jpg',
  'https://d5mup2f167kag.cloudfront.net/assets/public/a6028d3b-6295-451c-a354-f8a4d7626be2-space-14.jpg',
  'https://d5mup2f167kag.cloudfront.net/assets/public/39b0654e-121b-4def-a80e-fe831b8135f4-space-15.jpg',
  // 'https://d5mup2f167kag.cloudfront.net/assets/public/dd22b851-0644-4253-9f47-31db572d1dd0-space-16.jpg',
];

export const ImageColorPresets = {
  colors,
  gradients,
  architectures,
  landScape,
  space,
  gathering,
};
